import { render } from "./Auth.vue?vue&type=template&id=781c5ec4&scoped=true&ts=true"
import script from "./Auth.vue?vue&type=script&lang=ts"
export * from "./Auth.vue?vue&type=script&lang=ts"

import "./Auth.vue?vue&type=style&index=0&id=781c5ec4&scoped=true&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781c5ec4"]])

export default __exports__